export default [
  {
    t: '命令列工具(CLI)', p: '1', checked: false, h: 'https://github.com/vuejs/vue-cli'
  },
  {
    t: '初始化', p: '1', checked: false, h: 'https://vuejs.org/guide/installation.html#CLI'
  },
  {
    t: '部件(Components)', p: '1', checked: false, h: 'https://vuejs.org/guide/components.html'
  },
  {
    t: '不換頁的路由(Routing)', p: '1', checked: false, h: 'https://vuejs.org/guide/routing.html'
  },
  {
    t: '資料綁定', p: '13', checked: false, h: 'https://vuejs.org/guide/syntax.html'
  },
  {
    t: '串列呈現', p: '1', checked: false, h: 'https://vuejs.org/guide/list.html'
  },
  {
    t: '事件與方法', p: '123', h: 'https://vuejs.org/guide/components.html#Custom-Events', checked: false
  },
  {
    t: '跨部件溝通', p: '2', checked: false, h: 'https://vuejs.org/guide/components.html#Composing-Components'
  },
  {
    t: '用github-page發佈', p: '12', checked: false
  },
  {
    t: 'Chrome開發套件', p: '2', h: 'https://chrome.google.com/webstore/detail/vuejs-devtools/nhdogjmejiglipccpnnnanhbledajbpd', checked: false
  },
  {
    t: '傳送http請求', p: '2', checked: false, h: 'https://github.com/vuejs/vue-resource'
  },
  {
    t: '狀態處理與追蹤', p: '2', checked: false, h: 'https://vuex.vuejs.org/en/intro.html'
  },
  {
    t: '安裝Vue模組', p: '23', checked: false, h: 'https://github.com/vuejs/awesome-vue#libraries--plugins'
  },
  {
    t: '安裝函式庫', p: '23', checked: false
  },
  {
    t: '安裝語言編譯', p: '3', checked: false
  },
  {
    t: '安裝SASS Mixins', p: '3', checked: false
  },
  {
    t: '漸變與動畫', p: '3', checked: false, h: 'https://vuejs.org/guide/transitions.html'
  }
]
